import { C11nEnv } from '../../interpreter/c11n-env';
import AnnotationsHandler from '..';

type ParameterValue = string | boolean | number | undefined;

AnnotationsHandler.registerHandler('@FIELD_META', (value: string, c11nEnv: C11nEnv) => {
  // TODO: Fix this type once FieldMetadata type is created in c11nEnv.
  let fieldmetaData: { [key: string]: any } = {};

  if (value.startsWith('.')) {
    fieldmetaData = c11nEnv.getFieldMetadata(value.substring(1));
  } else {
    fieldmetaData = c11nEnv.getFieldMetadata(value);
  }

  let newParameters;
  if (fieldmetaData && fieldmetaData.datasource && fieldmetaData.datasource.parameters) {
    // prepend parent property before evaluating parameters
    let parentPropertyName = '';
    const parentPropertySplitArray = value.split('.').filter((val) => !!val);
    if (parentPropertySplitArray.length > 1) {
      parentPropertySplitArray.pop();
      parentPropertyName = `.${parentPropertySplitArray.join('.')}`;
    }

    if (Array.isArray(fieldmetaData.datasource.parameters)) {
      const newparams: { [key: string]: ParameterValue }[] = [];
      fieldmetaData.datasource.parameters.forEach((parameter: { name: string; value: ParameterValue }) => {
        const obj: { [key: string]: ParameterValue } = {};
        const { name, value: paramValue } = parameter;
        obj.name = name;
        if (typeof paramValue === 'string' && paramValue.startsWith('@P')) {
          obj.value = `@P ${parentPropertyName}${paramValue.substring(3)}`;
        } else {
          obj.value = paramValue;
        }
        newparams.push(c11nEnv.resolveConfigProps(obj));
      });
      newParameters = newparams;
    } else {
      // Here datasource.parameters will be an object (for query type properties)
      // TODO: FIXME Handle the prepending of parent property before evaluating parameters for objects when the feedback item,
      // "FEEDBACK-91603 Support for Query type property having parameterized DP configured via reference" is supported.
      newParameters = c11nEnv.resolveConfigProps(fieldmetaData.datasource.parameters);
    }

    fieldmetaData = {
      ...fieldmetaData,
      datasource: {
        ...fieldmetaData.datasource,
        parameters: newParameters
      }
    };
  }

  return fieldmetaData;
});
